import { Component, OnInit, ViewChild } from '@angular/core';
import { pageRoute } from '../../../../constant/pageRoute';
import { CompanyManageService } from '../../../../service/api/jubili/company-manage.service';
import { ActivatedRoute } from '@angular/router';
import { CompanySettingFormModel } from '../../../../model/jubili/company-manage/company-setting-form-data';
import { JubiliEditCompanyFormModalComponent } from '../../../shared/jubili-edit-company-form-modal/jubili-edit-company-form-modal.component';
import { SuccessModalComponent } from '../../../shared/success-modal/success-modal.component';

@Component({
  selector: 'app-company-setting-form',
  templateUrl: './company-setting-form.component.html',
  styleUrls: ['./company-setting-form.component.scss']
})
export class CompanySettingFormComponent implements OnInit {

  constructor(
    private companyManageService: CompanyManageService,
    private readonly route: ActivatedRoute,
  ) { }

  jubSettingFormUrl = pageRoute.jubSettingForm;
  companySurrKey: number;
  companySettingFormData: Array<CompanySettingFormModel>;
  @ViewChild("editFormModal") editFormModal: JubiliEditCompanyFormModalComponent;
  @ViewChild("successModal") successModal: SuccessModalComponent;
  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.companySurrKey = Number(params.get("id"));
    });
    this.getCompanySettingFormBackOffice();
  }
  getCompanySettingFormBackOffice() {
    this.companyManageService.getCompanySettingFormBackOffice(this.companySurrKey).subscribe(res => {
      this.companySettingFormData = res;
    });
  }
  onUpdateSuccess() {
    this.editFormModal.hide();
    this.successModal.show();
    this.getCompanySettingFormBackOffice();
  }
}
